import { GzMoveToActionWebComponent } from './component/GzMoveToActionWebComponent';

export { GzMoveToActionWebComponent };
